import DOMPurify from 'dompurify';

export const escapeHTML = (html) => {
	return DOMPurify.sanitize(html);
}
